import UpdateHydrantRequestModelBase from '../_generated/modelBases/update-hydrant-request-model-base';

export default class UpdateHydrantRequestModel extends UpdateHydrantRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
